import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const PiggyBankMiniIcon = ({
  width = 18,
  color = 'black',
  marginRight,
  marginLeft,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 22">
      <path
        fill={getSemanticTextColor(color)}
        fillRule="evenodd"
        d="M8.516 6.445c.267-.025.735-.059 1.039-.059.136 0 .266.01.399.015 4.106.165 7.452 2.876 7.904 6.335l.026.231v1.1c-.196 2.35-1.717 4.443-4.095 5.64l-.258.124v2.061h-2.387v-1.329c-.402.07-.798.107-1.194.126-.817.035-1.617-.032-2.398-.199l-.388-.092v1.491H4.778v-2.476c-1.342-.8-2.38-1.918-2.986-3.206l-.123-.279h-1.67v-4.775h1.67c.582-1.402 1.7-2.646 3.137-3.502-.056-.397-.148-.979-.811-1.706l-.151-.158-.573-.573s3.472-.373 5.245 1.231zm-2.733 3.633c-.853 0-1.546.694-1.546 1.546 0 .853.693 1.546 1.546 1.546.853 0 1.546-.693 1.546-1.546 0-.852-.693-1.546-1.546-1.546zM10.406.001c1.239-.004 2.239 1 2.239 2.238 0 1.237-1.003 2.238-2.239 2.238-1.238 0-2.238-1.004-2.238-2.238C8.168 1 9.172 0 10.407 0z"
      />
    </svg>
  </DefaultIconWrapper>
);
